function run() {
    $(() => {
        console.log('Initialized Page Script...');
    });
}
export const page_payments = {
    requiresAuth: true,
    run: run,
};
//# sourceMappingURL=payments.js.map